import loginHero from '~/assets/login-hero.png';

export const LoginImages = () => {
  return (
    <div className="flex justify-center">
      <img
        src={loginHero}
        alt="HealthcareLX and MedCredVault"
        className="w-[540px] max-w-full h-auto object-contain"
      />
    </div>
  );
};
